import { toRem } from "../../helpers/theme";

const style = ({ theme }) => ({
    display: "flex",
    flex: 1,
    flexDirection: "column",
    "& .uploaderGallery": {
        "&_grid": {
            position: "relative",
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gridColumnGap: toRem(10),
            gridRowGap: toRem(10),
            width: "100%",
            maxWidth: "100%",
            [theme.breakpoints.up("md")]: {
                gridTemplateColumns: "repeat(4, 1fr)",
            },
        },
    },
});

export default style;
